<template>
    <div class="variable-statement-files-view detail-card">
        <div class="card-header">
            <div class="title">
                <div>{{ title }}</div>
                <!-- <div style="font-size: 9pt; font-weight: normal; color: #aaa;">(合約、報價單、手開發票留存、作廢發票留存)</div> -->
            </div>
            <el-button v-if="!disabled && !isQR()" type="primary" plain style="margin-left: 10px;" icon="el-icon-plus" size="mini" @click="onAdd">
                新增文件
            </el-button>
        </div>
        <div class="card-body">
            <el-table :data="data" :empty-text="emptyText">
                <el-table-column prop="filE_ATT" width="150" label="檔案">
                    <template slot-scope="scope">
                        <div v-if="scope.row.filE_ATT">
                            <el-image v-if="getAttTyp(scope.row.filE_ATT) !== 'pdf'" style="width: 100%; border: 1px solid #ccc" :src="scope.row.filE_ATT" :previewSrcList="[scope.row.filE_ATT]">
                            </el-image>
                            <ahFileIcon v-else ext="pdf" :url="scope.row.filE_ATT" />
                        </div>
                        <div v-else>(無)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="nam" label="文件名稱／備註">
                    <template slot-scope="scope">
                        <div class="file-name">{{ scope.row.nam }}</div>
                        <div class="file-note">{{ scope.row.note }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="updateUser" label="上傳人" width="120">
                    <template slot-scope="scope">
                        <div>{{ scope.row.updateUser }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="updateUser" label="上傳日期" width="110">
                    <template slot-scope="scope">
                        <div>{{ scope.row.updateTime | dateFormater("YYYY-MM-dd") }}</div>
                    </template>
                </el-table-column>
                <el-table-column v-if="!disabled && !isQR()" prop="action" label="操作" width="90">
                    <template slot-scope="scope">
                        <el-dropdown @command="onMoreDropdownClick($event, scope.row, scope.$index)">
                            <el-button size="mini">
                                <i class="el-icon-more" />
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="edit">編輯</el-dropdown-item>
                                <el-dropdown-item command="remove">刪除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <FilesEditDialog
            :visible="filesEditDialog.visible"
            :createMode="createMode"
            :parentForm="form"
            :editForm="filesEditDialog.form"
            @close="onFilesEditDialogClose"
            @create="onCreate"
            @remove="onRemove"
        />
    </div>
</template>

<script>
import _ from 'lodash';
import FilesEditDialog from '@/components/dashboard/Finance/VariableStatement/FilesEditDialog.vue';
import ahFileIcon from '@/components/ui/ahFileIcon.vue';

export default {
    components: { FilesEditDialog, ahFileIcon },
    props: {
        title: {
            type: String,
            default: '檢附文件',
        },
        emptyText: {
            type: String,
            default: '無資料',
        },
        form: {
            type: Object,
            default: () => {},
        },
        createMode: Boolean,
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            filesEditDialog: { visible: false, form: null },
            editIndex: null,
        };
    },
    computed: {
        data() {
            return _.map(this.form.attachments, (o) => ({
                filE_ATT: o.attachmentUrl,
                updateUser: o.upD_NAM || o.crT_NAM,
                updateTime: o.upD_DAT || o.crT_DAT,
                nam: o.nam,
                note: o.note,
                sno: o.sno,
            }));
        },
    },
    methods: {
        onAdd() {
            this.filesEditDialog.visible = true;
        },
        onFilesEditDialogClose(reload) {
            this.filesEditDialog.visible = false;
            this.filesEditDialog.form = null;
            this.editIndex = null;
            if (reload) this.$emit('reload');
        },
        async onMoreDropdownClick(command, row, index) {
            console.log(command, row, index);
            if (command === 'edit') {
                this.filesEditDialog.form = row;
                this.filesEditDialog.visible = true;
                this.editIndex = index;
            } else if (command === 'remove') {
                try {
                    await this.$confirm('確定要刪除此文件？', {
                        confirmButtonText: '確定',
                        cancelButtonText: '取消',
                    });
                    await this.onRemove(row.sno);
                } catch (e) {
                    console.log(e);
                }
            }
        },

        async onRemove(sno) {
            if (this.createMode) {
                this.data.splice(this.editIndex, 1);
                this.$emit(
                    'change',
                    _.map(this.data, (o) => ({
                        sno: o.sno,
                        filE_ATT: o.filE_ATT,
                        nam: o.nam,
                        note: o.note,
                        invoiceSno: null,
                    })),
                );
                return;
            }

            const attachments = [...this.form.attachments];
            const REPLACE_INDEX = _.findIndex(this.form.attachments, ['sno', sno]);
            attachments.splice(REPLACE_INDEX, 1);

            await this.$api({
                url: 'VariableStatementSettingPage/UpsertStatementForm',
                method: 'POST',
                data: {
                    ...this.form,
                    attachments: _.map(attachments, (o) => ({
                        attachmentUrl: o.filE_ATT || o.attachmentUrl,
                        nam: o.nam,
                        note: o.note,
                        sno: o.sno,
                    })),
                },
            });
            this.$message({
                showClose: true,
                message: '已刪除文件',
                type: 'success',
            });
            this.$emit('reload');
        },

        onCreate(item) {
            const EXIST = item.sno && _.findIndex(this.data, ['sno', item.sno]);

            if (this.editIndex !== null) this.data.splice(this.editIndex, 1, item);
            else if (EXIST) this.data.splice(EXIST, 1, item);
            else this.data.push(item);

            this.$emit(
                'change',
                _.map(this.data, (o) => ({
                    filE_ATT: o.filE_ATT,
                    nam: o.nam,
                    note: o.note,
                    updateUser: o.updateUser,
                    updateTime: o.updateTime,
                })),
            );
        },

        getAttTyp(fileAtt) {
            return fileAtt
                ?.split('.')
                .pop()
                .toLowerCase();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
.variable-statement-files-view {
    &.detail-card {
        margin: 0;
        padding: 0px;
    }
    .create-mode-header {
        display: flex;
        justify-content: flex-end;
    }
    .file-name {
        color: $main-color;
    }
    .file-note {
        font-size: 10pt;
        color: #888888;
    }
    .card-header {
        display: flex;
        justify-content: space-between;
        font-size: 12pt;
        font-weight: bold;
        color: $main-color;
        margin-bottom: 20px;
    }
}
</style>
